"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectOS = exports.detectDevices = void 0;
var enums_1 = require("./enums");
// inpired by https://gist.github.com/Takazudo/979855
function detectUA(userAgent) {
    var regExps = [
        { regex: /iPhone/i, identity: 'iPhone' },
        { regex: /iPad/i, identity: 'iPad' },
        { regex: /Android/i, identity: 'Android' },
        { regex: /Mac/i, identity: 'Mac' },
        { regex: /Win/i, identity: 'Windows' },
        { regex: /Linux/i, identity: 'Linux' },
    ];
    var ua = regExps.reduce(function (map, _a) {
        var _b;
        var identity = _a.identity, regex = _a.regex;
        return (__assign(__assign({}, map), (_b = {}, _b[identity] = regex.test(userAgent), _b)));
    }, {});
    ua.AndroidTablet = !!ua.Android && !/mobile/i.test(userAgent);
    ua.tablet = !!ua.iPad || ua.AndroidTablet;
    return ua;
}
/**
 * Simple implementation for devices detection
 * Not cover 100% patterns for now, will continue to make it better
 */
function detectDevices(userAgent) {
    var ua = detectUA(userAgent);
    if (ua.tablet) {
        return enums_1.DEVICES.Tablet;
    }
    if (ua.iPhone || ua.Android) {
        return enums_1.DEVICES.Phone;
    }
    return enums_1.DEVICES.PC;
}
exports.detectDevices = detectDevices;
/**
 * Simple implementation for OS detection
 * Not cover 100% patterns for now, will continue to make it better
 */
function detectOS(userAgent) {
    var ua = detectUA(userAgent);
    if (ua.iPhone || ua.iPad) {
        return enums_1.OPERATING_SYSTEMS.iOS;
    }
    if (ua.Android) {
        return enums_1.OPERATING_SYSTEMS.Android;
    }
    if (ua.Mac) {
        return enums_1.OPERATING_SYSTEMS.OSx;
    }
    if (ua.Windows) {
        return enums_1.OPERATING_SYSTEMS.Windows;
    }
    if (ua.Linux) {
        return enums_1.OPERATING_SYSTEMS.Linux;
    }
    return enums_1.OPERATING_SYSTEMS.unknown;
}
exports.detectOS = detectOS;
//# sourceMappingURL=detectors.js.map